export const sortByDate = (
  a: Date | null | undefined,
  b: Date | null | undefined,
  sortedBy: 'asc' | 'desc' = 'desc',
) => {
  if (!a && !b) {
    return 0;
  }
  if (sortedBy === 'asc') {
    if (!a) {
      return -1;
    }
    if (!b) {
      return 1;
    }
    return a.getTime() - b.getTime();
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  return b.getTime() - a.getTime();
};
